import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';

@Component({
  selector: 'nw-line-height-selector',
  templateUrl: './line-height-selector.component.html',
  styleUrls: ['./line-height-selector.component.scss'],
})
export class LineHeightSelectorComponent {
  currentLineHeight: number;

  constructor(private readonly store: Store) {}

  @Input()
  set lineHeight(val: number) {
    this.currentLineHeight = val;
  }
}
